import { Filter } from '@cubejs-client/core';

import { DimNegotiationCaseDimension } from '~/common/types/cubes/DimNegotiationCase';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { NegotiationCountWidget, NegotiationCountWidgetProps } from './NegotiationCountWidget';

export const SupplierNegotiationCountWidget = ({ spendType }: NegotiationCountWidgetProps) => {
  const { entityId } = useModuleContext();
  const filters: Filter[] = [
    {
      member: DimNegotiationCaseDimension.SUPPLIER_ID,
      operator: 'equals',
      values: [entityId],
    },
  ];
  return <NegotiationCountWidget filters={filters} spendType={spendType} />;
};
